import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { API_URL } from "../../redux/constants";
import { requestCloseCase } from "../../redux/UserActions";
import { ArchiveIcon } from "@heroicons/react/solid";

export default function ChatInfo({ chat }) {
  const userSelector = useSelector((state) => state.user);

  const [firstName, setFirstName] = useState(
    chat?.people[0]?._id["$oid"] != userSelector.user._id
      ? chat.people[0]?.firstName
      : chat.people[1].firstName
  );
  const [lastName, setLastName] = useState(
    chat?.people[0]?._id["$oid"] != userSelector.user._id
      ? chat.people[0].lastName
      : chat.people[1].lastName
  );

  const [countryCode, setCountryCode] = useState(
    chat?.people[0]?._id["$oid"] != userSelector.user._id
      ? chat.people[0].countryCode
      : chat.people[1].countryCode
  );

  const [phoneNumber, setPhoneNumber] = useState(
    chat?.people[0]?._id["$oid"] != userSelector.user._id
      ? chat.people[0].phoneNumber
      : chat.people[1].phoneNumber
  );

  const [profilePicture, setProfilePicture] = useState(
    API_URL +
      "image/profile/" +
      (chat?.people[0]?._id["$oid"] != userSelector.user._id
        ? String(chat?.people[0]?._id["$oid"])
        : String(chat?.people[1]?._id["$oid"]))
  );

  const dispatch = useDispatch();

  function requestClose() {
    document.getElementById("message-input").value = "";
    dispatch(
      requestCloseCase({
        caseId: chat.caseId,
        action: "request",
      })
    );
  }

  return (
    <div className="flex flex-row px-5 py-5 gap-x-2 items-center h-20 border-b">
      {profilePicture === "" ? (
        <div
          className={
            "w-10 h-10 flex bg-blue-200 rounded-full items-center justify-center text-black font-medium text-sm pointer-events-none"
          }
        >
          {firstName[0] + lastName[0]}
        </div>
      ) : (
        <img
          src={profilePicture}
          className={
            "w-10 h-10 bg-red-200 rounded-full pointer-events-none object-cover"
          }
        />
      )}
      {
        <label className="flex-grow w-full text-lg font-medium text-gray-700 pointer-events-none">
          {firstName + " " + lastName}
        </label>
      }
      {
        <button
          onClick={() => requestClose()}
          className="flex-none justify-self-end rounded-lg bg-gray-100 text-lg font-medium my-2 p-2"
        >
          <ArchiveIcon className="w-8 h-8" />
        </button>
      }
    </div>
  );
}
